import $ from 'jquery';
import initAudio from './audio';

const $episodes = $( '.js-video-episodes' );
const $featuredVideos = $( '.js-featured-videos' );

const $wrappers = $( '.c-video-wrapper[data-video-url]' );

$( window ).on( 'load', function() {
	if ( $episodes && $episodes.length ) {
		$episodes.on( 'click', '.js-video-episode', function( e ) {
			e.preventDefault();

			if ( $( this ).hasClass( 'is-active' ) ) {
				return;
			}
			
			if ( ! $featuredVideos || ! $featuredVideos.length ) {
				return;
			}
			
			
			const $episode = $( this );
			const episodeId = $episode.attr( 'data-episode-id' );
			
			$episodes.find( '.js-video-episode.is-active' ).removeClass( 'is-active' );
			$episodes
			.find( '.js-video-episode .c-card__label--active' )
			.removeClass( 'c-card__label--active' );
			$episodes
			.find( '.js-video-episode .c-card__label-text--active' )
			.removeClass( 'c-card__label-text--active' );
			
			$episode.addClass( 'is-active' );
			$episode.find( '.c-card__label' ).addClass( 'c-card__label--active' );
			$episode.find( '.c-card__label-text' ).addClass( 'c-card__label-text--active' );
			
			$featuredVideos.find( '.c-card:not(.c-card--inactive)' ).addClass( 'c-card--inactive' );
			
			const $featuredVideo = $featuredVideos.find( `.c-card[data-episode-id="${episodeId}"]` );
			
			$featuredVideo
			.removeClass( 'c-card--inactive' );
			
			const $featuredEpisode = $featuredVideo.find( '.js-featured-episode' );
			
			if ( $featuredEpisode.hasClass( 'js-audio' ) ) {
				initAudio( $featuredEpisode );
			} else {
				// only start loading audio episodes when the episode is clicked,
				// because the audio waveform doesn't render while the audio
				// player is hidden
				const $clickedAudioEpisode = $featuredVideo.find( '.js-audio' );
				if ($clickedAudioEpisode) {
					initAudio( $clickedAudioEpisode );
				}
			}

		} );
	}

	if ( $wrappers.length ) {
		$wrappers.each( function() {
			var $wrapper = $( this );

			var $button = $wrapper.find( '.c-video-wrapper__button' );

			if ( $button.length ) {
				$button.on( 'click', function( e ) {
					e.preventDefault();
					$( this ).hide();

					let doingAjax = false;

					if ( ! doingAjax ) {
						$.ajax( {
							url: window.emagazine_script.ajax_url,
							data: {
								action: 'emagazine_get_oembed_video',
								video_url: $wrapper.attr( 'data-video-url' ),
							},
							dataType: 'json',
							method: 'GET',
							beforeSend: function() {
								$wrapper.find( '.c-video-wrapper__loader' ).addClass( 'active' );
								doingAjax = true;
							},
						} )
							.done( function( response ) {
								if ( response.success ) {
									$wrapper.html( response.success );

									$wrapper
										.closest( '.c-card__figure' )
										.find( '.c-card__duration' )
										.addClass( 'u-hidden' );

									$wrapper
										.closest( '.c-card__figure' )
										.addClass( 'c-card__figure--video' );

									$wrapper
										.addClass( 'c-video-wrapper--active' );

									$wrapper
										.find( '.c-video-wrapper__loader' )
										.removeClass( 'active' );
								}

								doingAjax = false;
							} )
							.fail( function( response ) {
								doingAjax = false;
							} );
					}
				} );
			}
		} );
	}
});
